import axios from '../../../axios';
import JobServeViewPartialCv from '../types/JobServeViewPartialCv';

export const postToViewPartialCv = async (payload: JobServeViewPartialCv) =>
  await axios.post('candidatesearch/api/job-serve/cv-partial-view', payload);
